'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.declMod = exports.decl = undefined;

var _inherit = require('inherit');

var _inherit2 = _interopRequireDefault(_inherit);

var _decls = require('bem-react-core/dist/lib/decls');

var _decls2 = _interopRequireDefault(_decls);

var _BaseComponent = require('bem-react-core/dist/lib/BaseComponent');

var _BaseComponent2 = _interopRequireDefault(_BaseComponent);

var _ClassNameBuilder = require('bem-react-core/dist/lib/ClassNameBuilder');

var _ClassNameBuilder2 = _interopRequireDefault(_ClassNameBuilder);

var _simpleComponent = require('bem-react-core/dist/lib/simpleComponent');

var _simpleComponent2 = _interopRequireDefault(_simpleComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqCount = 0;

var classBuilder = new _ClassNameBuilder2.default({
    elementSeparator: '__',
    modSeparator: '_',
    modValueSeparator: '_'
});

var BaseComponent = (0, _inherit2.default)(_BaseComponent2.default, {
    willInit: function willInit() {
        this.state = {};
        this.__uniqId = {};
    },
    generateId: function generateId() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '__uniqId';

        return this.__uniqId[key] ? this.__uniqId[key] : this.__uniqId[key] = 'uniq$' + ++uniqCount;
    }
}, {
    classBuilder: classBuilder,
    bool2string: function bool2string(val) {
        return val ? 'yes' : false;
    }
});

var legoDecls = (0, _decls2.default)({}, BaseComponent, classBuilder);

var decl = legoDecls.decl,
    declMod = legoDecls.declMod;
exports.decl = decl;
exports.declMod = declMod;
exports.default = (0, _simpleComponent2.default)(classBuilder);